import _classCallCheck from "/Users/wuliang/WorkSpace.localized/courses/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/wuliang/WorkSpace.localized/courses/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/Users/wuliang/WorkSpace.localized/courses/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/wuliang/WorkSpace.localized/courses/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/wuliang/WorkSpace.localized/courses/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { TokenType as tt } from "../parser/tokenizer/types";
import Transformer from "./Transformer";
/**
 * Transformer supporting the optional chaining and nullish coalescing operators.
 *
 * Tech plan here:
 * https://github.com/alangpierce/sucrase/wiki/Sucrase-Optional-Chaining-and-Nullish-Coalescing-Technical-Plan
 *
 * The prefix and suffix code snippets are handled by TokenProcessor, and this transformer handles
 * the operators themselves.
 */

var OptionalChainingNullishTransformer = /*#__PURE__*/function (_Transformer) {
  _inherits(OptionalChainingNullishTransformer, _Transformer);

  var _super = _createSuper(OptionalChainingNullishTransformer);

  function OptionalChainingNullishTransformer(tokens, nameManager) {
    var _this;

    _classCallCheck(this, OptionalChainingNullishTransformer);

    _this = _super.call(this);
    _this.tokens = tokens;
    _this.nameManager = nameManager;
    ;
    return _this;
  }

  _createClass(OptionalChainingNullishTransformer, [{
    key: "process",
    value: function process() {
      if (this.tokens.matches1(tt.nullishCoalescing)) {
        var _token = this.tokens.currentToken();

        if (this.tokens.tokens[_token.nullishStartIndex].isAsyncOperation) {
          this.tokens.replaceTokenTrimmingLeftWhitespace(", async () => (");
        } else {
          this.tokens.replaceTokenTrimmingLeftWhitespace(", () => (");
        }

        return true;
      }

      if (this.tokens.matches1(tt._delete)) {
        var nextToken = this.tokens.tokenAtRelativeIndex(1);

        if (nextToken.isOptionalChainStart) {
          this.tokens.removeInitialToken();
          return true;
        }
      }

      var token = this.tokens.currentToken();
      var chainStart = token.subscriptStartIndex;

      if (chainStart != null && this.tokens.tokens[chainStart].isOptionalChainStart && // Super subscripts can't be optional (since super is never null/undefined), and the syntax
      // relies on the subscript being intact, so leave this token alone.
      this.tokens.tokenAtRelativeIndex(-1).type !== tt._super) {
        var param = this.nameManager.claimFreeName("_");
        var arrowStartSnippet;

        if (chainStart > 0 && this.tokens.matches1AtIndex(chainStart - 1, tt._delete) && this.isLastSubscriptInChain()) {
          // Delete operations are special: we already removed the delete keyword, and to still
          // perform a delete, we need to insert a delete in the very last part of the chain, which
          // in correct code will always be a property access.
          arrowStartSnippet = "".concat(param, " => delete ").concat(param);
        } else {
          arrowStartSnippet = "".concat(param, " => ").concat(param);
        }

        if (this.tokens.tokens[chainStart].isAsyncOperation) {
          arrowStartSnippet = "async ".concat(arrowStartSnippet);
        }

        if (this.tokens.matches2(tt.questionDot, tt.parenL) || this.tokens.matches2(tt.questionDot, tt.lessThan)) {
          if (this.justSkippedSuper()) {
            this.tokens.appendCode(".bind(this)");
          }

          this.tokens.replaceTokenTrimmingLeftWhitespace(", 'optionalCall', ".concat(arrowStartSnippet));
        } else if (this.tokens.matches2(tt.questionDot, tt.bracketL)) {
          this.tokens.replaceTokenTrimmingLeftWhitespace(", 'optionalAccess', ".concat(arrowStartSnippet));
        } else if (this.tokens.matches1(tt.questionDot)) {
          this.tokens.replaceTokenTrimmingLeftWhitespace(", 'optionalAccess', ".concat(arrowStartSnippet, "."));
        } else if (this.tokens.matches1(tt.dot)) {
          this.tokens.replaceTokenTrimmingLeftWhitespace(", 'access', ".concat(arrowStartSnippet, "."));
        } else if (this.tokens.matches1(tt.bracketL)) {
          this.tokens.replaceTokenTrimmingLeftWhitespace(", 'access', ".concat(arrowStartSnippet, "["));
        } else if (this.tokens.matches1(tt.parenL)) {
          if (this.justSkippedSuper()) {
            this.tokens.appendCode(".bind(this)");
          }

          this.tokens.replaceTokenTrimmingLeftWhitespace(", 'call', ".concat(arrowStartSnippet, "("));
        } else {
          throw new Error("Unexpected subscript operator in optional chain.");
        }

        return true;
      }

      return false;
    }
    /**
     * Determine if the current token is the last of its chain, so that we know whether it's eligible
     * to have a delete op inserted.
     *
     * We can do this by walking forward until we determine one way or another. Each
     * isOptionalChainStart token must be paired with exactly one isOptionalChainEnd token after it in
     * a nesting way, so we can track depth and walk to the end of the chain (the point where the
     * depth goes negative) and see if any other subscript token is after us in the chain.
     */

  }, {
    key: "isLastSubscriptInChain",
    value: function isLastSubscriptInChain() {
      var depth = 0;

      for (var i = this.tokens.currentIndex() + 1;; i++) {
        if (i >= this.tokens.tokens.length) {
          throw new Error("Reached the end of the code while finding the end of the access chain.");
        }

        if (this.tokens.tokens[i].isOptionalChainStart) {
          depth++;
        } else if (this.tokens.tokens[i].isOptionalChainEnd) {
          depth--;
        }

        if (depth < 0) {
          return true;
        } // This subscript token is a later one in the same chain.


        if (depth === 0 && this.tokens.tokens[i].subscriptStartIndex != null) {
          return false;
        }
      }
    }
    /**
     * Determine if we are the open-paren in an expression like super.a()?.b.
     *
     * We can do this by walking backward to find the previous subscript. If that subscript was
     * preceded by a super, then we must be the subscript after it, so if this is a call expression,
     * we'll need to attach the right context.
     */

  }, {
    key: "justSkippedSuper",
    value: function justSkippedSuper() {
      var depth = 0;
      var index = this.tokens.currentIndex() - 1;

      while (true) {
        if (index < 0) {
          throw new Error("Reached the start of the code while finding the start of the access chain.");
        }

        if (this.tokens.tokens[index].isOptionalChainStart) {
          depth--;
        } else if (this.tokens.tokens[index].isOptionalChainEnd) {
          depth++;
        }

        if (depth < 0) {
          return false;
        } // This subscript token is a later one in the same chain.


        if (depth === 0 && this.tokens.tokens[index].subscriptStartIndex != null) {
          return this.tokens.tokens[index - 1].type === tt._super;
        }

        index--;
      }
    }
  }]);

  return OptionalChainingNullishTransformer;
}(Transformer);

export { OptionalChainingNullishTransformer as default };